/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CouponDto } from './couponDto';


export interface BoughtCouponDto { 
    id?: number;
    uuid?: string;
    boughtAt?: string;
    expiration?: string;
    expirationTime?: string;
    activationEndsAt?: string;
    activationWindowSeconds?: number;
    status?: BoughtCouponDto.StatusEnum;
    redeemedAt?: string;
    redeemType?: BoughtCouponDto.RedeemTypeEnum;
    coupon?: CouponDto;
    externalCode?: string;
}
export namespace BoughtCouponDto {
    export type StatusEnum = 'ACTIVE' | 'EXPIRED' | 'REDEEMED' | 'TO_BE_REDEEMED' | 'CANCELLED';
    export const StatusEnum = {
        Active: 'ACTIVE' as StatusEnum,
        Expired: 'EXPIRED' as StatusEnum,
        Redeemed: 'REDEEMED' as StatusEnum,
        ToBeRedeemed: 'TO_BE_REDEEMED' as StatusEnum,
        Cancelled: 'CANCELLED' as StatusEnum
    };
    export type RedeemTypeEnum = 'SCANNED' | 'TIME_ACTIVATION' | 'SELF_MARKED' | 'STAFF_MARKED';
    export const RedeemTypeEnum = {
        Scanned: 'SCANNED' as RedeemTypeEnum,
        TimeActivation: 'TIME_ACTIVATION' as RedeemTypeEnum,
        SelfMarked: 'SELF_MARKED' as RedeemTypeEnum,
        StaffMarked: 'STAFF_MARKED' as RedeemTypeEnum
    };
}


